import React, { useState } from 'react';
import { Button, Form, Alert, Spinner } from 'react-bootstrap'
import Popup from 'reactjs-popup'
import axios from 'lib/axios'
import Select from 'UI/Select'
import _ from 'lodash'

const ImportCSV = ({ importPath, objectName, fieldsOptions, uniqueByFieldsOptions }) => {
  const [file, loadFile] = useState(null);
  const [loadingFile, updateSaveState] = useState(false)
  const [responseMessage, setResponseMessage] = useState(null)
  const [selectedFields, selectFields] = useState([])
  const [uniqByField, setUniqField] = useState(null)

  const postFile = () => {
    const formData = new FormData()
    let fields = _.map(fieldsOptions, field => field.value)
    if (!_.isEmpty(selectedFields)) {
      fields = _.map(selectedFields, field => field.value)
    }
    fields.push('id')

    formData.append('csv_file', file)
    formData.append('fields', fields)
    formData.append('uniq_by', uniqByField)
    updateSaveState(true)

    axios.post(importPath, formData)
    .then(({ data }) => {
      setResponseMessage(data.message)
      updateSaveState(false)

      setTimeout(() => window.location.reload(), 1000)
    })
    .catch(({ response }) => {
      setResponseMessage(response.data.message)
      updateSaveState(false)
    })
  }

  return (
    <Popup modal trigger={<Button variant="outline-primary" className="mt-2">Import</Button>}>
      {close => (
        <>
          {loadingFile && (
              <div className='spinner-container'>
                <Spinner animation="border" variant='secondary' />
              </div>
            )}
          <div className={loadingFile ? 'loading' : ''}>
            <div className="modal-popup">
              <div className="header">
              Import {objectName}</div>
              {responseMessage && (
                <Alert variant={responseMessage.variant}>
                  {responseMessage.text}
                </Alert>
              )}
              <div className="content">
                <Form.Group controlId='csvFile'>
                  <Form.Label>Select CSV file to import</Form.Label>
                  <Form.Control
                    type="file"
                    className='form-control'
                    style={{ padding: 0, height: 'unset', marginBottom: '1rem' }} accept=".csv"
                    onChange={(e) => loadFile(e.target.files[0])}
                  />
                  <Form.Label>Select {objectName} uniqe field to import by</Form.Label>
                  <Select
                    options={uniqueByFieldsOptions}
                    onChange={({ value }) => setUniqField(value)}
                  />
                  <Form.Label>Select {objectName} fields to import or leave blank for all</Form.Label>
                  <Select
                    isMulti
                    options={fieldsOptions}
                    onChange={value => selectFields(value)}
                  />
                </Form.Group>
              </div>
              <div className="actions">
                <Button variant="outline-primary" className="mr-2" onClick={close}>
                  Cancel
                </Button>
                <Button variant="primary" onClick={() => postFile()} disabled={loadingFile}>
                  Import
                </Button>
              </div>
            </div>
          </div>
        </>
      )}
    </Popup>
  )
}

export default ImportCSV
